import slice from './slice';

export const {
    loadJobs, addJob, removeJob, reset, setJob, updateLocalJobState,
    updateDisplayedCompoundJobs, setJobState,
} = slice.actions;
export default slice.reducer;
